'use client'

import { Link } from '@/navigation'
import { useTranslations } from 'next-intl'
import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IconCard } from '@/components/common'
import { Global, StatsUp, TwoUser } from '@/components/icons'

const HighStandards = () => {
  const t = useTranslations('HighStandards')

  const data = [
    {
      icon: <Global className="h-9 w-9" />,
      title: t('item_one.title'),
      description: t('item_one.description'),
    },
    {
      icon: <StatsUp className="h-9 w-9" />,
      title: t('item_two.title'),
      description: t('item_two.description'),
    },
    {
      icon: <TwoUser className="h-9 w-9" />,
      title: t('item_three.title'),
      description: t('item_three.description'),
    },
  ]
  return (
    <section className="container mx-auto py-[30px] md:py-12">
      <div>
        <h2 className="mb-5 text-center md:mb-10">{t('title')}</h2>
        <Swiper
          modules={[Autoplay]}
          autoplay
          breakpoints={{
            428: { slidesPerView: 1 },
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={24}
          className="mb-5 md:mb-10"
        >
          {data.map((props, i) => (
            <SwiperSlide key={'standards-card' + props.title + i}>
              <IconCard {...props} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="flex justify-center">
          <Link href="/services" className="btn-primary" aria-label={t('button')}>
            {t('button')}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default HighStandards
